import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster/angular2-toaster';


@Component({
    selector: 'set-password',
    templateUrl: 'set-password.template.html',
})
export class SetPasswordComponent {
    year = new Date().getFullYear();
    setPasswordForm: FormGroup;
    token: string;
    private sub: any;

    constructor(private fb: FormBuilder,
                private http: Http,
                private toasterService: ToasterService,
                private router: Router,
                private route: ActivatedRoute) {
        this.sub = this.route.params.subscribe(params => {
            this.token = params['token'];
        });
    }

    ngOnInit(): void {
        this.createForm();
    }

    createForm() {
        const password = new FormControl('', Validators.compose([
            Validators.required,
            Validators.minLength(6),
        ]));
        const confirmPassword = new FormControl('', Validators.compose([
            Validators.required,
            Validators.minLength(6),
            CustomValidators.equalTo(password)
        ]));
        this.setPasswordForm = this.fb.group({
            password: password,
            confirmPassword: confirmPassword,
        });
    }

    submit(model, isValid: boolean) {
        if (!isValid) {
            return false;
        }
        this.setPasswordForm.disable();
        const headers = new Headers();
        headers.append('Authorization', this.token);
        this.http.post('/passwords/restore', {
            password: model.password
        },  new RequestOptions({
            headers: headers,
        }))
            .map(r => r.json())
            .finally(() => {
                this.setPasswordForm.enable();
            })
            .subscribe((response) => {
                this.toasterService.pop('success', 'Success', response.data)
                this.router.navigate(['/login'])
            })

    }
}




// WEBPACK FOOTER //
// ./src/app/views/set-password/set-password.component.ts